import React from 'react';
import ReactDOM from 'react-dom/client';


import '../src/commonResource/css/bootstrap.css'
import '../src/index.css'
import '../src/commonResource/css/styles.css'
import App from './App';
// import "font-awesome/css/font-awesome.min.css";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


